import React from "react";
import classes from './BackdropPopup.module.css'

const BackdropPopup = ({ children, myHeight }) => {

    return (
        <div className={classes.BackdropPopupContainer}>
            <div className={classes.BackdropPopup} style={{ height: myHeight ? myHeight : '316px' }}>
                {children}
            </div>
        </div>
    )
}

export default BackdropPopup;